<template lang="pug">
    multiselect-form(
        ref="categorySelector"
        :value="value",
        name="categorySelector",
        :options="categories",
        placeholder="Type to search or create category",
        item-placeholder="Add this as new category",
        @create="submit",
        @add-item="onAddedItem",
        @show-form="onShowForm",
        @hide-form="onHideForm",
        @input="onInput",
        title="Category",
        loader-name="save-category",
        :close-on-select="true",
        :hide-selected="false",
        :multiple="false",
        form-title="Create New Category"
    )
        template(slot="body")
            form(id="categoryForm")
                fieldset(:disabled="loading")
                    div.md-form-group
                        input.md-input(
                            placeholder="e.g Food",
                            id="category-name"
                            type="text",
                            v-model="category.name",
                            required
                        )
                        label Name

                    div.md-form-group
                        textarea(
                            rows="2",
                            class="md-input",
                            v-model="category.description"
                        )
                        label Description
</template>

<script>
import multiselectForm from './multiselect-form.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: { multiselectForm },

    props: {
        value: {
            type: null,
            default: () => null,
        },
    },

    data() {
        return {
            category: null,
        };
    },

    computed: {
        ...mapGetters('category', ['categories']),

        loading() {
            return this.onLoading('save-category');
        },
    },

    created() {
        this.category = this.newCategory();
    },

    mounted() {
        this.registerEvent();
    },

    methods: {
        ...mapActions('category', ['createCategory', 'getNewCategory']),

        newCategory() {
            return {
                id: null,
                name: null,
                description: null,
            };
        },

        submit() {
            if (!this.validateForm('categoryForm')) return;

            this.createCategory(this.category)
                .then(res => {
                    this.$emit('item-created', res.data);
                })
                .catch(err => {
                    this.showApiError(err);
                });
        },

        focusOnForm() {
            setTimeout(() => {
                document.getElementById('category-name').focus();
            }, 100);
        },

        onAddedItem(name) {
            this.category.name = name;
        },

        onShowForm() {
            this.focusOnForm();
        },

        onHideForm() {
            this.category = this.newCategory();
        },

        registerEvent() {
            this.$on('item-created', item => {
                this.$refs.categorySelector.$emit('item-created', item);
            });
        },

        onInput(value) {
            this.$emit('input', value);
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/category-selector.vue